fragment TextLeftImageRightFragment on textLeftImageRight_Entry {
  typeHandle
  heading
  body
  cta {
    ...LinkFragment
  }
  ctaClaim
  image {
    url
    title
  }
  imageAlt
  overlayImage {
    url
    title
  }
  overlayImageAlt
}
